function scrollDown()
{
    const icon = document.getElementById('scroll-down');

    if (icon) {
        icon.addEventListener('click', function () {
            const viewportHeight = window.innerHeight - 100;
            window.scrollTo({top: viewportHeight, behavior: 'smooth'});
        });
    }
}

export { scrollDown };
